import { createFileRoute } from "@tanstack/react-router";

import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";

import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { ProfessionalDataContactInformationSection } from "@/components/profile/professional-data/professional-data-contact-information-section";
import { ProfessionalDataSection } from "@/components/profile/professional-data/professional-data-section";
import { useGraphQL } from "@/hooks/use-graphql.ts";

import type { JSX } from "react";

const ProfessionalDataPageQuery = graphql(/* GraphQL */ `
  query ProfessionalDataPageQuery {
    usuarios {
      ...ProfessionalDataSectionFragment
      ...ProfessionalDataContactInformationSectionFragment
    }
  }
`);

const ProfessionalDataPage = (): JSX.Element => {
  const queryResult = useGraphQL(ProfessionalDataPageQuery, {});
  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Dados Profissionais" align="center" />
      </HeaderRoot>
      <Page className="px-6 py-8">
        <AsyncDataWrapper {...queryResult}>
          {data?.usuarios ? (
            <div className="flex flex-col gap-6">
              <ProfessionalDataSection data={data.usuarios} />
              <ProfessionalDataContactInformationSection data={data.usuarios} />
            </div>
          ) : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/profile/professional-data/")({
  component: ProfessionalDataPage,
});
